export var handleWidgetRadiusType = function handleWidgetRadiusType(radius) {
  switch (radius) {
    case 'ROUNDED':
      return 'rounded';
    case 'SHARP':
      return 'sharp';
    case 'NORMAL':
    default:
      return 'normal';
  }
};
export var handleWidgetSpaceType = function handleWidgetSpaceType(space) {
  switch (space) {
    case 'COSY':
      return 'cosy';
    case 'GENEROUS':
      return 'generous';
    case 'COMFORTABLE':
    default:
      return 'comfortable';
  }
};
export var handleWidgetPosition = function handleWidgetPosition(position) {
  switch (position) {
    case 'CENTER':
      return 'CENTER';
    case 'CORNER':
    default:
      return 'CORNER';
  }
};
export var handleChatBubbleVariant = function handleChatBubbleVariant(variant) {
  switch (variant) {
    case 'LIGHT':
      return 'light';
    case 'DARK':
      return 'dark';
    case 'VIBRANT':
      return 'vibrant';
    case 'DEFAULT':
    default:
      return 'default';
  }
};
export var handleWidgetButtonVariant = function handleWidgetButtonVariant(variant) {
  switch (variant) {
    case 'LIGHT':
      return 'light';
    case 'DARK':
      return 'dark';
    case 'VIBRANT':
      return 'vibrant';
    case 'DEFAULT':
    default:
      return 'dark';
  }
};